import { useEffect, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { useParams } from 'react-router-dom';
import { StoreState } from '@root/types';
import actions from '@store/actions/listingPage';
import { getListing } from '@store/selectors';
import useMarketo from '@root/shared/useMarketo';
import TruvaLayout from '../Layout';
import ListingLayout from './Layout';
import useListingBreadcrumbs from './useListingPageBreadcrumbs';
import NotFound from '../404/NotFound';

const mapDispatch = {
  listingPageLoad: (listingId: string, isPreview: boolean) =>
    actions.listingPageLoad({ id: listingId, isPreview }),
  buildingBreadcrumbClicked: () => actions.buildingBreadcrumbClicked(),
  searchBreadcrumbClicked: () => actions.searchBreadcrumbClicked(),
};

const mapState = (state: StoreState, ownProps: { match: { params: { listingId: string } } }) => ({
  listingId: ownProps.match.params.listingId,
  listing: getListing(state, ownProps.match.params.listingId),
});

const connector = connect(mapState, mapDispatch);
type ReduxProps = ConnectedProps<typeof connector>;

type PassedProps = {
  isPreview?: boolean;
  isShare?: boolean;
};

export const RawListing = ({
  listing,
  isPreview = false,
  isShare = false,
  listingPageLoad,
  buildingBreadcrumbClicked,
  searchBreadcrumbClicked,
}: PassedProps & ReduxProps) => {
  const [loading, setLoading] = useState(true);
  let { listingId } = useParams<{ listingId: string }>();

  if (listing && isShare) {
    listingId = listing.id;
  }

  useMarketo();

  useEffect(() => {
    listingPageLoad(listingId, isPreview).then(() => {
      setLoading(false);
    });
  }, [listingId, isPreview]);

  useListingBreadcrumbs(listing, buildingBreadcrumbClicked, searchBreadcrumbClicked);

  if (loading) return null;

  return listing ? (
    <TruvaLayout>
      <ListingLayout listing={listing} isShare={isShare} isPreview={isPreview} />
    </TruvaLayout>
  ) : (
    <NotFound />
  );
};

export default connector(RawListing);
